import { render, staticRenderFns } from "./ModulePages.vue?vue&type=template&id=24b689f0&scoped=true&"
import script from "./ModulePages.vue?vue&type=script&lang=ts&"
export * from "./ModulePages.vue?vue&type=script&lang=ts&"
import style0 from "./ModulePages.vue?vue&type=style&index=0&id=24b689f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b689f0",
  null
  
)

export default component.exports